<div class="app-wrapper">
    <app-header (valueChange)="displayChange($event)" [url]="url"></app-header>
    <div class="home-content" *ngIf="url==='/home' || url==='/'">
        <router-outlet></router-outlet>
        <app-search></app-search>
    </div>

    <div class="main">
        <div class="main-content" *ngIf="url!='/home' && url!='/'">
            <app-search *ngIf="mostrarSearch"></app-search>
            <router-outlet></router-outlet>
        </div>
        <div class="row">
            <app-carrusel *ngIf="visible"></app-carrusel>
            <!-- <app-lasmasbuscadas></app-lasmasbuscadas>-->
            <app-contactanos *ngIf="visible2"></app-contactanos>
        </div>
        <!--<button class="feed-back-button feed-back-button-left outline d-none d-md-block" style="border: medium none; background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%; left: 0px; margin-bottom: 0px;" alt="COMENTA" tabindex="0">
        <div class="triangle"></div>
        <div class="triangle-text triangle-bottom">COMENTA</div>
    </button>-->
        <!-- <app-pop-up></app-pop-up> -->
        <!--<app-redes></app-redes>-->
        <!--BOTON WHATSAPP-->
        <app-whatsapp></app-whatsapp>
    </div>
    <app-footer></app-footer>
</div>